import React from 'react'
import {SelectValidator} from '../../components/Letflow/Form';
import localization from '../../config/localization';
import {ImagePicker} from 'components/Letflow/Form'
import {TextValidator} from "react-material-ui-form-validator";

const FormContent = ({
  type,
  onChange,
  image,
  color,
  onImageChange
}) => {
  const types = [
    {id: 'favorite', name: localization.get("favorite")},
    {id: 'saved_query', name: localization.get("saved_query")},
    {id: 'playlist', name: localization.get("playlist")},
    {id: 'recent', name: localization.get("recent")},
    {id: 'pitch', name: localization.get("project")}
  ]
  return (
    <div>
      <SelectValidator
        style={{ width: "100%", marginBottom: "20px" }}
        id='type'
        name="type"
        current={type}
        title={localization.get('form.type')}
        onChange={onChange}
        items={types}
        validators={['required']}
        errorMessages={[localization.get('validator.is_required')]}
      />
      {(type === "playlist" || type === 'saved_query' || type === 'pitch') &&
        <TextValidator
          id="color"
          name="color"
          type="color"
          inputProps={{
            style: {
              height: 50
            }
          }}
          style={{width: 200, marginBottom: 20}}
          onChange={onChange}
          label="Color"
          value={color}
          validators={['required']}
          errorMessages={[localization.get('validator.is_required')]}
        />
      }
      <ImagePicker buttonText={localization.get('form.select_image')} image={image != null ? image.src : null} onImageChange={onImageChange} />
    </div>
  )
}

export default FormContent
